import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPause = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "1.125em",
	height: "1.125em",
	viewBox: "0 0 24 24",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M9 5C9.82843 5 10.5 5.67157 10.5 6.5V17.5C10.5 18.3284 9.82843 19 9 19H8C7.17157 19 6.5 18.3284 6.5 17.5V6.5C6.5 5.67157 7.17157 5 8 5H9Z",
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M16 5C16.8284 5 17.5 5.67157 17.5 6.5V17.5C17.5 18.3284 16.8284 19 16 19H15C14.1716 19 13.5 18.3284 13.5 17.5V6.5C13.5 5.67157 14.1716 5 15 5H16Z",
		fill: "currentColor"
	})]
});
export default SvgPause;
